import React, { useEffect, useState } from "react";
// import {ForceGraph2D} from "react-force-graph";

const GraphComponent = ({metadata = [], width = undefined, height = undefined}) => {
  const [graph, setGraph] = useState({ nodes: [], links: [] });
  // const [nodes, setNodes] = useState({});

  useEffect(() => {
    const uniqueNodes = Array.from(
      new Set(metadata.flatMap(item => [item.subject, item.object]))
    ).map((node, index) => ({ id: node, label: node }));

    const nodesObj = {};
    for (const node of uniqueNodes) {
      nodesObj[node.id] = node.id;
    }
    // setNodes(nodesObObj);
    setGraph({
      nodes: uniqueNodes,
      links: metadata?.map((item, index) => ({
        id: `${item?.subject}-${item?.predicate}-${item?.object}`,
        source: item?.subject,
        target: item?.object,
        label: item.predicate,
        name: item.predicate,
      }))
    });
  }, [metadata]);

  return null;

  // return metadata?.length ? <ForceGraph2D
  //   graphData={graph} nodeLabel="label" height={height} width={width} // Set width dynamically
  //   nodeCanvasObject={(node, ctx, globalScale) => {
  //     const radius = 1;
  //     ctx.beginPath();
  //     ctx.arc(node.x, node.y, radius, 0, 2 * Math.PI, false);
  //     ctx.fillStyle = "lightblue";
  //     ctx.fill();
  //     ctx.lineWidth = 0.1;
  //     ctx.strokeStyle = "lightblue";
  //     ctx.stroke();
  //
  //     ctx.font = `${12 / globalScale}px Sans-Serif`;
  //     ctx.textAlign = "center";
  //     ctx.textBaseline = "top";
  //     ctx.fillStyle = "black";
  //     const labelText = node?.label?.split(" ").splice(0, 6)?.join(" ");
  //     ctx.fillText(labelText, node.x, node.y + radius + 0.5);
  //   }}
  //   linkCanvasObject={(link, ctx, globalScale) => {
  //     const start = link.source;
  //     const end = link.target;
  //     const midX = (start.x + end.x) / 2;
  //     const midY = (start.y + end.y) / 2;
  //
  //     ctx.beginPath();
  //     ctx.moveTo(start.x, start.y);
  //     ctx.lineTo(end.x, end.y);
  //     ctx.strokeStyle = "lightgrey";
  //     ctx.lineWidth = 0.1;
  //     ctx.stroke();
  //
  //     ctx.font = `${10 / globalScale}px Sans-Serif`;
  //     ctx.textAlign = "center";
  //     ctx.textBaseline = "middle";
  //     ctx.fillStyle = "black";
  //     ctx.fillText(link.label, midX, midY);
  //   }}
  // /> : null;
};

export default GraphComponent;
